import { get } from 'api';

import {
  LOAD_OFFICE_LOCATIONS,
  LOAD_PAYMENT_TERMS,
  RESET_PAYMENT_TERMS,
  LOAD_TRANSPORT_METHODS,
  OFFICE_LOCATIONS_FAILED,
  OFFICE_LOCATIONS_LOADED,
  PAYMENT_TERMS_FAILED,
  PAYMENT_TERMS_LOADED,
  RESET_METADATA,
  TRANSPORT_METHODS_FAILED,
  TRANSPORT_METHODS_LOADED,
} from './actionTypes';
import transportMethods from './mocks/transportMethods.json';
import type { IMetadataActions } from './types';
import { APP_PRODUCT_TYPE } from 'appConstants';
import { productTypeUrlPrefix } from 'utils';

export const initialActionsState = {
  loadOfficeLocations: () => {},
  loadPaymentTerms: () => {},
  resetPaymentTerms: () => {},
  loadTransportMethods: () => {},

  resetMetadata: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
}): IMetadataActions => ({
  loadOfficeLocations: async (productType = APP_PRODUCT_TYPE.FERTILISER) => {
    dispatch({
      type: LOAD_OFFICE_LOCATIONS,
    });

    const { data, error } = await get(productTypeUrlPrefix(productType, '/office-locations'));

    if (data && !error) {
      dispatch({
        type: OFFICE_LOCATIONS_LOADED,
        payload: { data, productType },
      });
    } else {
      dispatch({
        type: OFFICE_LOCATIONS_FAILED,
        payload: error,
      });
    }
  },

  loadPaymentTerms: async (productType = APP_PRODUCT_TYPE.FERTILISER) => {
    dispatch({
      type: LOAD_PAYMENT_TERMS,
    });

    const { data, error } = await get(productTypeUrlPrefix(productType, '/payment-terms'));

    if (data && !error) {
      dispatch({
        type: PAYMENT_TERMS_LOADED,
        payload: { data, productType },
      });
    } else {
      dispatch({
        type: PAYMENT_TERMS_FAILED,
        payload: error,
      });
    }
  },
  resetPaymentTerms: () => {
    dispatch({
      type: RESET_PAYMENT_TERMS,
    });
  },
  loadTransportMethods: async () => {
    dispatch({
      type: LOAD_TRANSPORT_METHODS,
    });

    // TODO: Use axios get function
    // const { data, error } = await get('/api/transportMethods');
    const [data, error] = [transportMethods, null];

    if (data && !error) {
      dispatch({
        type: TRANSPORT_METHODS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: TRANSPORT_METHODS_FAILED,
        payload: error,
      });
    }
  },

  resetMetadata: () =>
    dispatch({
      type: RESET_METADATA,
    }),
});
